module.exports = __webpack_public_path__ + "static/img/geotap-game-indie-corner-feature.58be8b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/laurels/geotap-game-indie-corner-feature.png
// module id = RRR9
// module chunks = 0